import React, { useCallback } from "react";
import TitleWithSwiper from "@components/swiper/TitleWithSwiper";
import ProductCard from "@components/card/ProductCard";
import styled from "@emotion/styled";
import { SwiperSlide } from "swiper/react";
import { useQuery } from "@tanstack/react-query";
import { useApiRequest } from "@utils/ApiRequest";
import useGenderStore from "@store/header/useGenderStore";

const ProductSwiperItem = styled(SwiperSlide)({
  display: "flex",
  flexGrow: 1,
  minWidth: "160px",
  maxWidth: "160px",
});

const LovesSwiper = () => {
  const { gender } = useGenderStore();
  const { getWeLovesList } = useApiRequest();
  const lang = window.localStorage.getItem("language");

  const { data: weLovesList } = useQuery({
    queryKey: ["weLovesList", gender],
    queryFn: () => getWeLovesList(gender === "men" ? 1002 : 1001),
  });

  return (
    <TitleWithSwiper title={"WE LOVE"} preview={"auto"} space={0}>
      {weLovesList?.map((product: any) => (
        <ProductSwiperItem key={product.product_id}>
          <ProductCard
            id={product.product_id}
            brand={
              lang === "en" ? product.brand_name_en : product.brand_name_ko
            }
            name={
              lang === "en" ? product.product_name_en : product.product_name_ko
            }
            src={product.thumbnail_url}
            price={product.price}
            likeCount={product.like_total}
            chatCount={product.qna_total}
            soldout={product.is_sold_out === 1}
            isLiked={product.is_liked}
            condition={product.product_condition}
            isActive={product.is_active ? false : true}
          />
        </ProductSwiperItem>
      ))}
    </TitleWithSwiper>
  );
};

export default LovesSwiper;
